import React from 'react';
import ModalComponent from '../../../../../components/common-components/modal/ModalComponent';
import Icons from '../../../../../components/icons/Icons';
import Button from '../../../../../components/common-components/button/Button';
import { BUTTON_VARIANTS } from '../../../../../components/common-components/button/Constants';

function MasterDeleteModel({ open, close,message }) {

    return (
        <ModalComponent
            open={open}
            title={'Delete ' + message}
            close={close}
            icon={<Icons iconName={'closeIcon'} />}
            footerButton={
                <div className="flex justify-between gap-2">
                    <Button
                        type="submit"
                        variant={BUTTON_VARIANTS.OUTLINED}
                        customBtnClass="text-met-primary"
                        onClickCb={() => close("no")}
                    >
                        No
                    </Button>
                    <Button
                        type="submit"
                        variant={BUTTON_VARIANTS.CONTAINED}
                        customBtnClass="text-met-primary"
                        onClickCb={() => {
                            close("yes")
                        }}
                    >
                        Yes
                    </Button>
                </div>
            }
            enableReinitialize
            customClasses="w-[40%]"
        >
            <div>
                <p>Do you want to delete this {message}?</p>
            </div>
        </ModalComponent>
    );
}

export default MasterDeleteModel;
